import {
	ArrowButtons,
	Breakpoints,
	BreakpointWrapper,
	Container,
	ContainerPadding,
	DecorativeImage,
	DesignTokenSizeEnum,
	Gallery,
	GallerySlide,
	Layout,
	LayoutProps,
	Text,
	TextProps,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import styled from 'styled-components';
import { GalleryNav } from '../components/gallery-nav';
import { ResponsiveText } from '../components/responsive-text';

export const arrowLeft =
	'data:image/svg+xml,%3Csvg%20width%3D%2240%22%20height%3D%2226%22%20viewBox%3D%220%200%2040%2026%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M13.774%2023.074C9.564%2019.304%206.15%2015.874%204.21%2013.806L40%2013.806L40%2011.146L4.246%2011.146C7.3063%207.97263%2010.4845%204.91515%2013.774%201.98L12%20-1.22392e-06C11.88%200.107999%20-4.70684e-07%2010.768%20-5.45343e-07%2012.476C-6.21926e-07%2014.228%2011.88%2024.948%2012%2025.056L13.774%2023.074Z%22%20fill%3D%22%23001E50%22%2F%3E%3C%2Fsvg%3E';

export const arrowRight =
	'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0MCAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjIyNiAxLjk4MjAzQzMwLjQzNiA1Ljc1MjAzIDMzLjg1IDkuMTgyMDMgMzUuNzkgMTEuMjVMMCAxMS4yNUwwIDEzLjkxTDM1Ljc1NCAxMy45MUMzMi42OTM3IDE3LjA4MzQgMjkuNTE1NSAyMC4xNDA5IDI2LjIyNiAyMy4wNzZMMjggMjUuMDU2QzI4LjEyIDI0Ljk0OCA0MCAxNC4yODggNDAgMTIuNThDNDAgMTAuODI4IDI4LjEyIDAuMTA4MDMxIDI4IDMuMDUxNzZlLTA1TDI2LjIyNiAxLjk4MjAzWiIgZmlsbD0iIzAwMUU1MCIvPgo8L3N2Zz4K';

const gridDisplay = {
	[Breakpoints.default]: [
		{ name: '.', columns: 2 },
		{ name: 'escuela-title', columns: 20 },
		{ name: '.', columns: 2 },
		{ name: '.', columns: 0 },
		{ name: 'escuela-gallery', columns: 24 },
		{ name: '.', columns: 0 },
	],
};

const EscuelaSectionLayout = styled(Layout)<LayoutProps>`
	padding-top: var(--size-dynamic0250);
	padding-bottom: var(--size-dynamic0150);
	background-color: var(--c-white);
`;

const ArrowButtonsContainer = styled.div`
	& > div {
		padding: 0 var(--size-grid001);
		margin-top: var(--size-grid001);

		@media (min-width: 560px) {
			& {
				margin-top: 0;
			}
		}

		& > button {
			background: none !important;
			width: var(--size-grid001);
			height: calc(var(--size-grid001) / 2);

			svg {
				display: none;
			}
			&:disabled {
				opacity: 0.3;
			}
			&::after {
				content: '';
				position: absolute;
				width: 100%;
				height: 100%;
				background-repeat: no-repeat;
				background-size: contain;
			}
			&:first-child::after {
				background-image: url(${arrowLeft});
				transform-origin: left center;
			}
			&:last-child::after {
				background-image: url(${arrowRight});
				transform-origin: right center;
			}
		}
	}
`;

const EscuelaContentContainer = styled(Container)`
	width: 100%;
	margin: 0 var(--size-grid002);
	max-width: var(--size-grid020);

	@media (min-width: 960px) {
		& {
			margin: 0 var(--size-grid003);
			max-width: var(--size-grid017);
		}
	}
	@media (min-width: 1920px) {
		& {
			max-width: var(--size-grid018);
		}
	}
`;

const EscuelaImage = styled.div<{ bgImage: string }>`
	display: flex;
	align-items: center;
	position: relative;
	aspect-ratio: 3/2;
	width: 100%;
	border-radius: 20px;
	margin-bottom: 90px;
	background-image: url(${(props) => props.bgImage});
	background-position: center;
	background-size: cover;

	&::before {
		content: '';
		position: absolute;
		height: 100%;
		width: 70%;
		border-radius: 20px;
		z-index: 0;
		background: none;
	}

	@media (min-width: 560px) {
		& {
			aspect-ratio: 2/1;
			margin-bottom: 0;
		}
	}
	@media (min-width: 960px) {
		& {
			max-height: 400px;
		}
		&::before {
			background: linear-gradient(90deg, rgba(0, 0, 0, 0.5), transparent);
		}
	}
	@media (min-width: 1600px) {
		& {
			max-height: 500px;
		}
	}
`;
const EscuelaName = styled(Text)<TextProps>`
	line-height: 100%;
	font-weight: lighter;
	z-index: 1;

	@media (min-width: 960px) {
		& {
			word-spacing: 100vw;
			padding-left: var(--size-grid001);
		}
	}
`;
const EscuelaBadge = styled(DecorativeImage)`
	width: 250px;
	height: 180px;
	object-fit: contain;
	object-position: center center;
	margin: 0 auto;
	top: 50%;
	right: 50%;
	left: unset;
	bottom: unset;
	transform: translate(0%, 0%);

	@media (min-width: 560px) {
		width: 230px;
		height: 160px;
		position: absolute;
		object-position: right center;
		transform: translate(0%, -50%);
		top: 100%;
		right: var(--size-grid001);
		bottom: unset;
		left: unset;
	}

	@media (min-width: 960px) {
		width: 250px;
		height: 180px;
		object-position: center center;
		transform: translate(-50%, -50%);
		top: 50%;
		left: 100%;
		bottom: unset;
		right: unset;
	}

	@media (min-width: 1920px) {
		width: 380px;
		height: 230px;
		object-position: right center;
		transform: translate(0%, -50%);
		top: 100%;
		right: var(--size-grid001);
		bottom: unset;
		left: unset;
	}
`;

const EscuelaContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--size-dynamic0100);

	justify-content: space-between;

	& > div:first-child {
		display: flex;
		flex-direction: column;
		width: 100%;

		gap: var(--size-dynamic0050);

		& * {
			text-wrap: pretty;
		}

		@media (min-width: 560px) {
			gap: var(--size-dynamic0100);
		}

		@media (min-width: 1920px) {
			max-width: var(--size-grid010);
		}

		.description-footer {
			display: flex;
			flex-direction: column;
			gap: var(--size-dynamic0050);

			.description-footer-item {
				padding: 0;
				border: none;
			}

			@media (min-width: 560px) {
				& {
					gap: 0;
					flex-direction: row;

					.description-footer-item {
						padding-right: 20px;

						&:not(:first-child) {
							padding-left: 20px;
						}
						&:not(:last-child) {
							border-right: 1px solid var(--c-grey200);
						}
					}
				}
			}
		}
	}
`;
const DescriptionFooterItems = styled.div`
	display: flex;
	gap: var(--size-grid002);

	@media (min-width: 560px) {
		gap: 0;
	}
`;

const GallerySlideContainer = styled(GallerySlide)`
	height: 100%;
	& > div {
		width: 100%;
		height: 100%;
	}
`;

export const EscuelaGallery = (): React.ReactElement => {
	const escuelaContent = [
		{
			title: 'Escuela GTI',
			image:
				'https://assets.volkswagen.com/is/image/volkswagenag/escuela_gallery_slide_1?Zml0PWNyb3AlMkMxJndpZD0xODYwJmhlaT05MTImZm10PWpwZWcmcWx0PTc5JmJmYz1vZmYmNTUzZg==',
			badge:
				'https://assets.volkswagen.com/is/image/volkswagenag/badge_master_gti-v2?Zml0PWNyb3AlMkMxJndpZD03MjYmaGVpPTM0NSZmbXQ9cG5nLWFscGhhJmJmYz1vZmYmZmQ0ZA==',
			description: {
				title: (
					<>
						La experiencia donde entiendes que <b>un GTI no es un coche: es carácter</b>
					</>
				),
				description:
					'Una escuela donde aprendes mejor control al volante y practicas la aceleración y frenada con esquiva en distintas salidas copilotadas a pista.',
				location: 'Circuito Jarama, Madrid',
				date: 'Junio 2026',
				terrain: 'Asfalto',
			},
		},
		{
			title: 'Track Experience',
			image:
				'https://assets.volkswagen.com/is/image/volkswagenag/escuela_gallery_slide_2?Zml0PWNyb3AlMkMxJndpZD0xODYyJmhlaT05MTImZm10PWpwZWcmcWx0PTc5JmJmYz1vZmYmMzI0MQ==',
			badge:
				'https://assets.volkswagen.com/is/image/volkswagenag/1badge_master_track_experience%201_1?Zml0PWNyb3AlMkMxJndpZD03MjMmaGVpPTUxOSZmbXQ9cG5nLWFscGhhJmJmYz1vZmYmNDJlNw==',
			description: {
				title: (
					<>
						Todo lo que necesitas saber para dominar el control <b>sobre el asfalto</b>
					</>
				),
				description:
					'Una experiencia conduciendo toda nuestra gama deportiva en pista y actividades en un circuito de conos a contrarreloj.',
				location: 'Circuito Aspar, Valencia',
				date: 'Octubre 2026',
				terrain: 'Asfalto',
			},
		},
		{
			title: 'Escuela 4Motion',
			image:
				'https://assets.volkswagen.com/is/image/volkswagenag/escuela_gallery_slide_3?Zml0PWNyb3AlMkMxJndpZD0xODYyJmhlaT05MTImZm10PWpwZWcmcWx0PTc5JmJmYz1vZmYmMzI0MQ==',
			badge:
				'https://assets.volkswagen.com/is/image/volkswagenag/badge_master_hielo_nieve-v2?Zml0PWNyb3AlMkMxJndpZD01MzImaGVpPTUyMSZmbXQ9cG5nLWFscGhhJmJmYz1vZmYmNmNkYQ==',
			description: {
				title: (
					<>
						No necesitas esquiar para sentir <b>la adrenalina en un día de nieve</b>
					</>
				),
				description:
					'La escuela diseñada para dominar la nieve con retos de slalom deslizante y aceleración sobre hielo y en un circuito libre. ',
				location: 'Circuito Pas de la Casa, Andorra',
				date: 'Febrero 2027',
				terrain: 'Hielo y nieve',
			},
		},
	];

	return (
		<EscuelaSectionLayout data-testid="escuela-gallery-section" appearance={gridDisplay}>
			<Container padding={{ bottom: ContainerPadding.dynamic0200 }} data-testid="info-heading" wrap={'always'}>
				<ResponsiveText
					appearance={{
						[Breakpoints.default]: TokenTextAppearance.headline400,
						[Breakpoints.b960]: TokenTextAppearance.headline500,
					}}
					color={TokenTextColor.primary}
				>
					Las escuelas a las que <b>te gustaría haber ido</b>
				</ResponsiveText>
			</Container>
			<Container wrap={'always'}>
				<BreakpointWrapper max={Breakpoints.b560}>
					<Gallery
						id="escuela-images-gallery"
						aria-label="Images Gallery"
						bottomElements={
							<div style={{ padding: '0 var(--size-grid002) 30px', marginTop: '-10px' }}>
								<div style={{ paddingTop: '30px' }}>
									<GalleryNav />
								</div>
							</div>
						}
					>
						{escuelaContent.map((escuela, index) => (
							<GallerySlideContainer key={escuela.title} aria-labelledby={`slide${index}-heading`}>
								<Container key={index} wrap={'always'} gutter={DesignTokenSizeEnum.dynamic0100}>
									<EscuelaContentContainer wrap={'always'}>
										<EscuelaBadge width={200} key={index} src={escuela.badge} />
									</EscuelaContentContainer>
									<EscuelaContentContainer wrap={'always'} gutter={DesignTokenSizeEnum.dynamic0200}>
										<EscuelaName
											key={index}
											appearance={TokenTextAppearance.headline500}
											color={TokenTextColor.primary}
										>
											{escuela.title}
										</EscuelaName>
										<EscuelaContent>
											<div>
												<Text appearance={TokenTextAppearance.headline300} color={TokenTextColor.primary}>
													{escuela.description.title}
												</Text>
												<ResponsiveText
													appearance={{
														[Breakpoints.default]: TokenTextAppearance.copy200,
														[Breakpoints.b960]: TokenTextAppearance.bigcopy100,
													}}
													color={TokenTextColor.primary}
												>
													{escuela.description.description}
												</ResponsiveText>
												<div className="description-footer">
													<div className="description-footer-item">
														<Text appearance={TokenTextAppearance.headline100} bold color={TokenTextColor.primary}>
															Ubicación
														</Text>
														<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
															{escuela.description.location}
														</Text>
													</div>
													<DescriptionFooterItems>
														<div className="description-footer-item">
															<Text appearance={TokenTextAppearance.headline100} bold color={TokenTextColor.primary}>
																Fecha
															</Text>
															<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
																{escuela.description.date}
															</Text>
														</div>
														<div className="description-footer-item">
															<Text appearance={TokenTextAppearance.headline100} bold color={TokenTextColor.primary}>
																Terreno
															</Text>
															<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
																{escuela.description.terrain}
															</Text>
														</div>
													</DescriptionFooterItems>
												</div>
											</div>
											{/* <div>
												<CTA tag="button" emphasis="nbab" onClick={onApuntateClick} aria-label="Apúntate" type="button">
													Apúntate
												</CTA>
											</div> */}
										</EscuelaContent>
									</EscuelaContentContainer>
								</Container>
							</GallerySlideContainer>
						))}
					</Gallery>
				</BreakpointWrapper>
				<BreakpointWrapper min={Breakpoints.b560} max={Breakpoints.b960}>
					<Gallery
						id="escuela-images-gallery"
						aria-label="Images Gallery"
						bottomElements={
							<div style={{ padding: '0 var(--size-grid002) 30px', marginTop: '-10px' }}>
								<div style={{ paddingTop: '30px' }}>
									<GalleryNav />
								</div>
							</div>
						}
					>
						{escuelaContent.map((escuela, index) => (
							<GallerySlideContainer key={escuela.title} aria-labelledby={`slide${index}-heading`}>
								<Container key={index} wrap={'always'} gutter={DesignTokenSizeEnum.dynamic0140}>
									<EscuelaContentContainer wrap={'always'} gutter={DesignTokenSizeEnum.dynamic0100}>
										<EscuelaImage key={index} bgImage={escuela.image}>
											<EscuelaBadge width={200} key={index} src={escuela.badge} />
										</EscuelaImage>
									</EscuelaContentContainer>
									<EscuelaContentContainer wrap={'always'} gutter={DesignTokenSizeEnum.dynamic0140}>
										<EscuelaName
											key={index}
											appearance={TokenTextAppearance.headline500}
											color={TokenTextColor.primary}
										>
											{escuela.title}
										</EscuelaName>
										<EscuelaContent>
											<div>
												<Text appearance={TokenTextAppearance.headline300} color={TokenTextColor.primary}>
													{escuela.description.title}
												</Text>
												<ResponsiveText
													appearance={{
														[Breakpoints.default]: TokenTextAppearance.copy200,
														[Breakpoints.b960]: TokenTextAppearance.bigcopy100,
													}}
													color={TokenTextColor.primary}
												>
													{escuela.description.description}
												</ResponsiveText>
												<div className="description-footer">
													<div className="description-footer-item">
														<Text appearance={TokenTextAppearance.headline100} bold color={TokenTextColor.primary}>
															Ubicación
														</Text>
														<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
															{escuela.description.location}
														</Text>
													</div>
													<div className="description-footer-item">
														<Text appearance={TokenTextAppearance.headline100} bold color={TokenTextColor.primary}>
															Fecha
														</Text>
														<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
															{escuela.description.date}
														</Text>
													</div>
													<div className="description-footer-item">
														<Text appearance={TokenTextAppearance.headline100} bold color={TokenTextColor.primary}>
															Terreno
														</Text>
														<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
															{escuela.description.terrain}
														</Text>
													</div>
												</div>
											</div>
											{/* <div>
												<CTA tag="button" emphasis="nbab" onClick={onApuntateClick} aria-label="Apúntate" type="button">
													Apúntate
												</CTA>
											</div> */}
										</EscuelaContent>
									</EscuelaContentContainer>
								</Container>
							</GallerySlideContainer>
						))}
					</Gallery>
				</BreakpointWrapper>
				<BreakpointWrapper min={Breakpoints.b960}>
					<Gallery
						id="escuela-full-gallery"
						aria-label="Full Gallery"
						data-testid="gallery-overflow-x-hidden"
						bottomElements={
							<ArrowButtonsContainer className="arrow-buttons-container">
								<ArrowButtons
									data-testid="arrow-buttons"
									buttonPreviousAriaLabel="Test previous"
									buttonNextAriaLabel="Test next"
								/>
							</ArrowButtonsContainer>
						}
					>
						{escuelaContent.map((escuela, index) => (
							<GallerySlideContainer key={escuela.title} aria-labelledby={`slide${index}-heading`}>
								<Container wrap={'always'} gutter={DesignTokenSizeEnum.dynamic0200}>
									<EscuelaContentContainer wrap={'always'} gutter={DesignTokenSizeEnum.dynamic0200}>
										<EscuelaImage key={index} bgImage={escuela.image}>
											<EscuelaName
												key={index}
												appearance={TokenTextAppearance.super100}
												color={TokenTextColor.inverted}
											>
												{escuela.title}
											</EscuelaName>
											<EscuelaBadge width={200} key={index} src={escuela.badge} />
										</EscuelaImage>
										<EscuelaContent>
											<div>
												<Text appearance={TokenTextAppearance.headline300} color={TokenTextColor.primary}>
													{escuela.description.title}
												</Text>
												<Text appearance={TokenTextAppearance.bigcopy100} color={TokenTextColor.primary}>
													{escuela.description.description}
												</Text>
												<div className="description-footer">
													<div className="description-footer-item">
														<Text appearance={TokenTextAppearance.headline100} bold color={TokenTextColor.primary}>
															Ubicación
														</Text>
														<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
															{escuela.description.location}
														</Text>
													</div>
													<div className="description-footer-item">
														<Text appearance={TokenTextAppearance.headline100} bold color={TokenTextColor.primary}>
															Fecha
														</Text>
														<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
															{escuela.description.date}
														</Text>
													</div>
													<div className="description-footer-item">
														<Text appearance={TokenTextAppearance.headline100} bold color={TokenTextColor.primary}>
															Terreno
														</Text>
														<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
															{escuela.description.terrain}
														</Text>
													</div>
												</div>
											</div>
											{/* <div>
												<CTA tag="button" emphasis="nbab" onClick={onApuntateClick} aria-label="Apúntate" type="button">
													Apúntate
												</CTA>
											</div> */}
										</EscuelaContent>
									</EscuelaContentContainer>
								</Container>
							</GallerySlideContainer>
						))}
					</Gallery>
				</BreakpointWrapper>
			</Container>
		</EscuelaSectionLayout>
	);
};
